import { GameScene } from '@Core/GameScene/GameScene';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { IDynamicCasinoJackpotConfig, TJackpotCasinoLevelItem } from '@GFTypes/index';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';

export class DynamicCasinoJackpotLevelsItem extends GameComponent {
    public scene: GameScene;
    private currentData: TJackpotCasinoLevelItem;

    constructor(scene: GameScene, levelData: TJackpotCasinoLevelItem) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'Dynamic Casino Jackpot Levels constructor'
        });
        this.currentData = levelData;
        this.run();
    }

    private run() {
        //run RAF
    }

    public update(data: TJackpotCasinoLevelItem) {}
}
